// const apiUrl = 'http://billing.vaspostproductions.com:8000/api';
const apiUrl = 'https://bs.aalantechsoft.com:8006/api';

export default apiUrl;